// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Axby","selects":"Documents_selects__1Iill"};